import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { PaymentService } from '../_services';
import * as paymentActions from '../_actions/payment';

@Injectable({
  providedIn: 'root',
})
export class PaymentEffects {
  loadpayments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(paymentActions.loadPayments),
      mergeMap(() =>
        this.paymentService.getPayments().pipe(
          map((payments) => paymentActions.loadpaymentsSuccess({ payments })),
          catchError((error) => of(paymentActions.loadpaymentsFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private paymentService: PaymentService
  ) {}
}
